function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { getTmsInstance } from 'integration-web-core--socle/js/assets/commons/_tms';
import { RecommendationComponent } from '../common/recommendation-component';
var SimilarComparator = /*#__PURE__*/function (_RecommendationCompon) {
  function SimilarComparator(section) {
    var _this;
    _classCallCheck(this, SimilarComparator);
    _this = _callSuper(this, SimilarComparator, [section]);
    _this.isExpanded = false;
    return _this;
  }
  _inherits(SimilarComparator, _RecommendationCompon);
  return _createClass(SimilarComparator, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(SimilarComparator.prototype), "init", this).call(this);
      this.toggleMoreLessCharacteristics();
      this.pushEventButtonClick();
      this.pushEventToggleButtonClick();
      if (window.innerWidth > 768) {
        this.setTableWidthAccordingToNumberOfItems();
      }
      this.setHeight();
      if (window.innerWidth < 768) {
        this.truncateCharacteristicsTitles();
        this.stickyToggleShowOnlyDifferencesCharacteristics();
      }
      this.toggleShowOnlyDifferencesCharacteristics();
      this.customUIForYourArticleTitle();
      this.initScrollButtons();
    }
  }, {
    key: "truncateCharacteristicsTitles",
    value: function truncateCharacteristicsTitles() {
      var characteristics = this.section.querySelectorAll('.similar-comparator__characteristic-title th div');
      var limit = 50;
      characteristics.forEach(function (characteristic) {
        var titleOfCharacteristic = characteristic.textContent.trim();
        if (titleOfCharacteristic.length > limit) {
          titleOfCharacteristic = titleOfCharacteristic.substring(0, limit);
          characteristic.textContent = "".concat(titleOfCharacteristic, "...");
        }
      });
    }
  }, {
    key: "customUIForYourArticleTitle",
    value: function customUIForYourArticleTitle() {
      var firstItem = this.section.querySelector('.recommendation-table__item');
      var yourArticleTitle = firstItem.querySelector('.recommendation-table__item h3');
      yourArticleTitle.classList.add('mc-flag');
      yourArticleTitle.classList.add('mc-flag--solid-dark');
    }

    /**
     * NOTE:
     *  this is a tricky fix for the height of the characteristics table because we can't use the display flex property in the table (maybe we can do better)
     *  the height is calculated based on the first item of the table, because this item has a other element inside that called "Your article"
     *  We get the height calculated by the browser and then we set the height to all the other items in the table which gives us the symmetrical items UI
     *
     *  TODO: explore diplay grid in table instead of this function
     */
  }, {
    key: "setHeight",
    value: function setHeight() {
      var firstRecommendedItemHeight = this.section.querySelector('.recommendation-table__item').offsetHeight;
      var firstRecommendedItemHeightInRem = this.pxToRem(firstRecommendedItemHeight);
      var allRecommendedItems = this.section.querySelectorAll('.recommendation-table__item');
      allRecommendedItems.forEach(function (recommendedItem) {
        recommendedItem.style.height = "".concat(firstRecommendedItemHeightInRem, "rem");
      });
    }
  }, {
    key: "setTableWidthAccordingToNumberOfItems",
    value: function setTableWidthAccordingToNumberOfItems() {
      var items = this.section.querySelectorAll('.recommendation-table__item');
      var table = this.section.querySelector('.similar-comparator__characteristics-table');
      var itemsLength = items.length;
      if (itemsLength <= 3) {
        table.style.width = '50%';
        table.style.margin = '0 auto';
      } else if (itemsLength === 4) {
        table.style.width = '70%';
        table.style.margin = '0 auto';
      } else {
        table.style.width = '100%';
      }
    }
  }, {
    key: "pxToRem",
    value: function pxToRem(pxValue) {
      var fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
      return pxValue / fontSize;
    }

    // TODO: needs to be refactored and properly tested
  }, {
    key: "toggleMoreLessCharacteristics",
    value: function toggleMoreLessCharacteristics() {
      var _this2 = this;
      var button = this.section.querySelector('.similar-comparator__button button');
      var toggleButton = this.section.querySelector('.similar-comparator__button--show-only-differences .mc-toggle__input');
      var buttonTxt = this.section.querySelector('.similar-comparator__button button span');
      var characteristics = this.section.querySelectorAll('.characteristic:not(.visible)');
      var characteristicsTitle = this.section.querySelectorAll('.similar-comparator__characteristic-title:not(.visible)');
      var svgElement = this.section.querySelector('.similar-comparator__button svg');
      var resetButtonState = function resetButtonState() {
        _this2.isExpanded = false;
        buttonTxt.textContent = button.getAttribute('data-text-initial');
        svgElement.classList.remove('rotate');
        characteristics.forEach(function (characteristic, index) {
          if (toggleButton.checked) {
            if (index >= 4) {
              characteristic.classList.remove('visible');
            } else {
              characteristic.classList.add('visible');
            }
          } else {
            characteristic.classList.remove('visible');
          }
        });
        characteristicsTitle.forEach(function (characteristicTitle, index) {
          if (toggleButton.checked) {
            if (index >= 4) {
              characteristicTitle.classList.remove('visible');
            } else {
              characteristicTitle.classList.add('visible');
            }
          } else {
            characteristicTitle.classList.remove('visible');
          }
        });
      };
      if (button) {
        button.addEventListener('click', function () {
          _this2.isExpanded = !_this2.isExpanded;
          characteristics.forEach(function (characteristic, index) {
            if (toggleButton.checked) {
              if (index >= 4) {
                characteristic.classList.toggle('visible', _this2.isExpanded);
              }
            } else {
              characteristic.classList.toggle('visible', _this2.isExpanded);
            }
          });
          characteristicsTitle.forEach(function (characteristicTitle, index) {
            if (toggleButton.checked) {
              if (index >= 4) {
                characteristicTitle.classList.toggle('visible', _this2.isExpanded);
              }
            } else {
              characteristicTitle.classList.toggle('visible', _this2.isExpanded);
            }
          });
          buttonTxt.textContent = _this2.isExpanded ? button.getAttribute('data-text-alternative') : button.getAttribute('data-text-initial');
          svgElement.classList.toggle('rotate');
        });
      }
      if (toggleButton) {
        toggleButton.addEventListener('change', resetButtonState);
      }
    }
  }, {
    key: "stickyToggleShowOnlyDifferencesCharacteristics",
    value: function stickyToggleShowOnlyDifferencesCharacteristics() {
      var button = document.querySelector('.similar-comparator__button--show-only-differences div');
      var comparatorContainer = document.querySelector('.similar-comparator__container');
      comparatorContainer.addEventListener('scroll', function () {
        button.style.transform = 'translateX(' + this.scrollLeft + 'px)';
      });
    }

    // TODO: needs to be refactored and properly tested
  }, {
    key: "toggleShowOnlyDifferencesCharacteristics",
    value: function toggleShowOnlyDifferencesCharacteristics() {
      var button = document.querySelector('.similar-comparator__button--show-only-differences .mc-toggle__input');
      var trElementWhichContainButton = document.querySelector('.similar-comparator__button--show-only-differences').parentElement;
      var characteristics = document.querySelectorAll('.characteristic');
      var showMoreCharacteristicsButton = this.section.querySelector('.similar-comparator__button button');
      if (characteristics.length > 1) {
        button.addEventListener('change', function (e) {
          var isChecked = e.target.checked;
          var _iterator = _createForOfIteratorHelper(characteristics),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var characteristic = _step.value;
              var characteristicValues = Array.from(characteristic.querySelectorAll('.characteristic td'));
              var uniqueValues = new Set(characteristicValues.map(function (value) {
                return value.textContent.trim();
              }));
              var characteristicTitle = characteristic.previousElementSibling;
              if (uniqueValues.size === 1) {
                characteristicTitle.classList.toggle('kl-hidden', e.target.checked);
                characteristic.classList.toggle('kl-hidden', e.target.checked);
              } else {
                characteristic.classList.remove('kl-hidden');
                characteristicTitle.classList.remove('kl-hidden');
                showMoreCharacteristicsButton.classList.toggle('kl-hidden', e.target.checked);
                if (isChecked) {
                  if (!characteristic.classList.contains('visible')) {
                    characteristic.classList.add('visible');
                    characteristicTitle.classList.add('visible');
                  }
                } else {
                  var index = Array.from(characteristics).indexOf(characteristic);
                  if (index >= 4) {
                    characteristic.classList.remove('visible');
                    characteristicTitle.classList.remove('visible');
                  }
                }
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        });
      } else {
        trElementWhichContainButton.classList.add('kl-hidden');
      }
    }
  }, {
    key: "pushEventButtonClick",
    value: function pushEventButtonClick() {
      var button = this.section.querySelector('.similar-comparator__button button');
      if (button) {
        button.addEventListener('click', function () {
          getTmsInstance().pushEvent(button, 'cdl_event', {
            event_name: 'button.click',
            event_data: {
              button_name: 'see more characteristics',
              feature_name: 'recommendation'
            }
          });
        }, {
          once: true
        });
      }
    }
  }, {
    key: "pushEventToggleButtonClick",
    value: function pushEventToggleButtonClick() {
      var button = this.section.querySelector('.similar-comparator__button--show-only-differences .mc-toggle__input');
      if (button) {
        button.addEventListener('click', function () {
          getTmsInstance().pushEvent(button, 'cdl_event', {
            event_name: 'button.click',
            event_data: {
              button_name: 'show only differences',
              feature_name: 'recommendation'
            }
          });
        }, {
          once: true
        });
      }
    }
  }, {
    key: "initScrollButtons",
    value: function initScrollButtons() {
      var prevButton = this.section.querySelector('[data-controls="prev"]');
      var nextButton = this.section.querySelector('[data-controls="next"]');
      var container = this.section.querySelector('.similar-comparator__container');
      var firstItemWidth = this.section.querySelector('.recommendation-table__item').offsetWidth;
      if (!prevButton || !nextButton || !container) {
        return;
      }
      var scrollAmount = firstItemWidth !== null && firstItemWidth !== void 0 ? firstItemWidth : 300; // Scroll by 300px on each button click (you can adjust this value)

      var updateButtonState = function updateButtonState() {
        var maxScrollLeft = container.scrollWidth - container.clientWidth;

        // Make sure prevButton and nextButton exist before accessing classList
        if (prevButton) {
          prevButton.classList.toggle('mc-carousel-header__button--disabled', container.scrollLeft <= 0);
        }
        if (nextButton) {
          nextButton.classList.toggle('mc-carousel-header__button--disabled', container.scrollLeft >= maxScrollLeft);
        }
      };

      // Scroll to the left
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          container.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
          });
          setTimeout(updateButtonState, 200); // Give time for the scroll animation to complete
        });
      }

      // Scroll to the right
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          container.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
          setTimeout(updateButtonState, 200); // Give time for the scroll animation to complete
        });
      }
      updateButtonState();
      container.addEventListener('scroll', updateButtonState);
    }
  }]);
}(RecommendationComponent);
_defineProperty(SimilarComparator, "selector", '.recommendation--comparator');
_defineProperty(SimilarComparator, "lazyLoadable", true);
export { SimilarComparator as default };
lm.DOMReady(function () {
  return SimilarComparator.setupOnceDomIsReady();
});